/**
 * Returnerer Path fra HN.Page objektet - eller tom string hvis den ikke finnes
 */
export const getPath = () => {
    return window.HN?.Page?.Path ?? '';
};
/**
 * Returnerer Assets fra HN.Page objektet
 */
export const getAssets = () => {
    return window.HN?.Page?.Assets;
};
/**
 * Returnerer Assets fra HN.Page objektet - eller tom string hvis den ikke finnes
 */
export const getAssetsUrl = () => {
    return window.HN?.Page?.Assets ?? '';
};
/**
 * Returnerer VerticalAssetsPath fra HN.Page objektet - eller tom string hvis den ikke finnes
 */
export const getVerticalAssetsPath = () => {
    return window.HN?.Page?.VerticalAssetsPath ?? '';
};
/**
 * Returnerer ElementGuid fra HN.Page objektet - eller tom string hvis den ikke finnes
 */
export const getElementGuid = () => {
    return window.HN?.Page?.ElementGuid ?? '';
};
/**
 * Oppdaterer Path key på HN.Page objektet
 * @param newPath verdien som settes i Path
 */
export const setPath = (newPath) => {
    window.HN = window.HN || {};
    window.HN.Page = window.HN.Page || {};
    window.HN.Page.Path = newPath;
};
/**
 * Hent ID som skal brukes på h1-elementet på siden
 * @returns ID
 */
export const getSidetittelId = () => 'sidetittel';
/**
 * Returnerer RedirectToUrlAfterLogin fra HN.Page-objektet - eller undefined hvis den ikke finnes
 */
export const getRedirectToUrlAfterLogin = () => {
    return window.HN?.Page?.RedirectToUrlAfterLogin;
};
/**
 * Returnerer DelAvForeldresamtykke fra HN.Page-objektet - eller undefined hvis den ikke finnes
 */
export const getDelAvForeldresamtykke = () => {
    return window.HN?.Page?.DelAvForeldresamtykke;
};
